import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=82497658"
import script from "./Confirmation.vue?vue&type=script&lang=js"
export * from "./Confirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports